import { Helmet } from "react-helmet";
import SecondHeader from "../../Header/SecondHeader";
import { useContext, useEffect, useState } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import UsersHead from "../../Users/UsersParts/UsersHead";
import { RegularForm } from "./RegularForm/Form";
import { filtrationcontext } from "../../../context/Filtercontext";
import AntdTable from "../../antd/Table/Table";
import trans, { isRTL } from "../../../utils";
import Actions from "../../antd/Table/Actions";
import { Tag } from "antd";
import { useGetAllRegularMaintenanceQuery } from "../../../Redux/service/Maintenance/MaintenanceNew";
import { useSelector } from "react-redux";

const RegularMaintenance = () => {
  let { handleShow, setEdited, edited, deleteItem, setDeleteItem } =
    useContext(popupcontext);
  const {
    limit,
    setLimit,
    setSort: SetSortFilter,
    searchQuery,
    setSearchQuery,
  } = useContext(filtrationcontext);

  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({ by: "", order: "" });
  const [trashMode, setTrashMode] = useState(false);
  const inf = useSelector((state) => state.users.user);

  const { data, isFetching, refetch } = useGetAllRegularMaintenanceQuery({
    page: currentPage,
    limit,
    sortBy: sort.by || undefined,
    sortOrder: sort.order || undefined,
    search: searchQuery || undefined,
    trash: trashMode || undefined,
  });

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
      setCurrentPage(1);
    } else {
      setSort({ by: "", order: "" });
    }
    setCurrentPage(pagination.current);
  };

  const renderInterval = (type, value) => {
    if (type === "hours") {
      const days = Math.floor(value / 24);
      const hours = value % 24;
      return hours > 0 ? `Every ${days} Days and ${hours} Hours` : `Every ${days} Days`;
    } else if (type === "odometer") {
      return `Every ${Math.round(value)} ${inf?.attributes?.distanceUnit}`;
    }
    return value;
  };

  useEffect(() => {
    async function fetchdata() {
      if (edited) {
        await refetch();
        setEdited(false);
      }
    }
    fetchdata();
  }, [edited]);

  useEffect(() => {
    async function fetchDataAfterDelete() {
      if (deleteItem.condition === true && deleteItem.value === "maintenance") {
        await refetch();
        setDeleteItem({ condition: null, value: null });
      }
    }
    fetchDataAfterDelete();
  }, [deleteItem.condition, deleteItem.value, refetch, setDeleteItem]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  useEffect(() => {
    setCurrentPage(1);
  }, [trashMode]);

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      setSearchQuery("");
    };
  }, [SetSortFilter, setSearchQuery]);

  const baseColumns = [
    {
      title: trans("Code"),
      dataIndex: "code",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      sorter: true,
      render: (value) => (
        <span className="table-element-name ps-0">{value}</span>
      ),
    },
    {
      title: trans("Maintenance Name"),
      dataIndex: "name",
      width: 300,
      sorter: true,
    },
    {
      title: trans("Type"),
      dataIndex: "type",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Priority"),
      dataIndex: "priority",
      width: 150,
      render: (value) => {
        const colorMap = {
          Highest: "red",
          High: "volcano",
          Medium: "orange",
          Low: "green",
        };
        return <Tag color={colorMap[value] || "default"}>{value}</Tag>;
      },
    },
    {
      title: trans("Start"),
      dataIndex: "start",
      width: 150,
      render: (value) => Math.round(value),
    },
    {
      title: trans("Intervals"),
      dataIndex: "period",
      width: 200,
      render: (_, record) => renderInterval(record.type, record.period),
    },
    {
      title: trans("Description"),
      dataIndex: "description",
      width: 250,
      render: (value) => (
        <div className="description-truncate">{value || "- - - -"}</div>
      ),
    },
    {
      title: trans("Created At"),
      dataIndex: "createdAt",
      width: 200,
      sorter: true,
      render: (value) => (value ? new Date(value).toLocaleString() : "- - - -"),
    },
  ];

  const trashColumn = {
    title: trans("Deleted At"),
    dataIndex: "deletedAt",
    width: 200,
    sorter: true,
    render: (value) => (value ? new Date(value).toLocaleString() : "- - - -"),
  };

  const actionsColumn = {
    title: trans("Actions"),
    width: 150,
    fixed: !isRTL ? "right" : undefined,
    render: ({ traccarId }) => <Actions maintenanceId={traccarId} />,
  };

  const columns = trashMode
    ? [...baseColumns, trashColumn]
    : [...baseColumns, actionsColumn];

  const items = data?.data || [];
  const total = data?.paginationInfo?.totalItems ?? items.length;

  return (
    <>
      <Helmet>
        <title>Regular Maintenance</title>
        <meta name="description" content="Regular Maintenance" />
      </Helmet>
      <SecondHeader
        title="Regular Maintenance"
        add={trashMode ? undefined : "New Regular Maintenance"}
        onClick={() => handleShow("addForm")}
        secButton={trashMode ? trans("Back to List") : trans("Trash")}
        secClick={() => setTrashMode((prev) => !prev)}
      />
      <UsersHead />
      <div className="bg-white-rounded-top mt-3 table-parent">
        <AntdTable
          columns={columns}
          dataSource={items}
          loading={isFetching}
          pageSize={limit}
          totalItems={total}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            setCurrentPage(1);
          }}
          onTableChange={handleTableChange}
        />
      </div>
      {!trashMode && <RegularForm data={data?.data} />}
    </>
  );
};

export default RegularMaintenance;
